var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowExpand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28574 14.714C4.96031 14.3886 4.96031 13.861 5.28574 13.5355L13.5353 5.28595C13.8608 4.96052 14.3884 4.96052 14.7138 5.28595C15.0393 5.61139 15.0393 6.13903 14.7138 6.46446L6.46426 14.714C6.13882 15.0395 5.61118 15.0395 5.28574 14.714Z",
    fill: "#68666C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.125 14.9581C13.6648 14.9581 13.2917 14.585 13.2917 14.1248L13.2917 6.70854L5.87542 6.70854C5.41518 6.70854 5.04209 6.33545 5.04209 5.87521C5.04209 5.41497 5.41518 5.04188 5.87542 5.04188L14.125 5.04188C14.5852 5.04188 14.9583 5.41497 14.9583 5.87521L14.9583 14.1248C14.9583 14.585 14.5852 14.9581 14.125 14.9581Z",
    fill: "#68666C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowExpand);
export default __webpack_public_path__ + "static/media/icon-arrow-expand.9635c528ae62a93281f6b5ba8b97ac71.svg";
export { ForwardRef as ReactComponent };